import React, { useState, useEffect } from "react";
import { useSignal } from 'react-signal-slot';
import Fetcher from "../Fetch";
import { IDocument, SignStatusses } from "./types";
import { TradeStatus } from "../../enums/TradeStatus"
import Loading from "../../Ui/Loading";
declare var CADESCOMSignData: any;

interface IProps {
    lotId: number;
    LotTradeStatusId: TradeStatus;
    IsShortInfo?: boolean;
    ArtTheme?: boolean;
}

function LotWinnerProtocol(props: IProps) {
    const { lotId } = props;
    const [loading, setLoading] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [doc, setDoc] = useState<IDocument>({
        DocumentId: null,
        DocumentName: '',
        SignStatusDescription: '',
        Signature: '',
        OrganizerCanSign: false,
        OrganizerSignStatus: 0,
        Thumbprint: '',
        WinnerCanSign: false,
        WinnerSignStatus: 0,
        DataToSign: '',
        IsOrganizer: false,
        Document: null
    });

    const signal = useSignal();

    const loadProtocolData = (onLoad: Function) => {
        Fetcher("/TradeEditApi/GetWinnerDocument?lotId=" + lotId,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.Success) {
                        setDoc(result.UpdatedItem);
                    }
                    onLoad();
                }
            );
    }

    useEffect(() => {
        if (isFirstLoad) {
            loadProtocolData(() => { setIsFirstLoad(false); });
        }
    }, []);

    const handleCreatePdf = () => {
        setLoading(true)
        Fetcher("/TradeEditApi/CreateWinnerDocument?lotId=" + lotId,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.Success) {
                        setDoc(result.UpdatedItem);
                        signal('protocolCreated', {
                            Id: result.UpdatedItem.DocumentId,
                            Name: result.UpdatedItem.DocumentName,
                            DocumentLink: `/Document/Details/${result.UpdatedItem.DocumentId}`,
                            DocumentTypeId: result.UpdatedItem.Document.DocumentTypeId,
                            AccountName: result.UpdatedItem.Document.AccountName,
                            Comment: result.UpdatedItem.Document.Comment,
                            MimeType: result.UpdatedItem.Document.MimeType
                        });
                    }
                    setLoading(false)
                }
            );
    }

    const handleSignProtocol = () => {
        CADESCOMSignData("hdnSignInfo",
            "hdnSignInfo",
            doc.Thumbprint,
            true,
            "hdnExistingSignData",
            true,
            function (signInfo) {
                Fetcher("/TradeEditApi/SignWinnerDocument",
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ SignInfo: signInfo, LotId: lotId })
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            if (result.Success) {
                                setDoc(result.UpdatedItem);
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            }
        );
    }

    const handleSignProtocolShort = () => {
        CADESCOMSignData(doc.DataToSign,
            doc.DataToSign,
            doc.Thumbprint,
            true,
            doc.Signature,
            true,
            function (signInfo) {
                Fetcher("/TradeEditApi/SignWinnerDocument",
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ SignInfo: signInfo, LotId: lotId })
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            if (result.Success) {
                                setDoc(result.UpdatedItem);
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            }
        );
    }

    if (isFirstLoad) {
        return <div className="col-0"></div>;
    }

    return (
        <>
            {loading && <Loading />}

            {/* Полная форма - для страницы лота*/}
            {!props.IsShortInfo && (
                <div className="col-0">
                    {!doc.DocumentId && doc.IsOrganizer && (
                        <button
                            id="btnCreateDocument"
                            className="btn btn-primary btn-font-14 btn-lg btn-block px-10 btn-sm-mobile defaultPinkButton"
                            onClick={handleCreatePdf}
                        >
                            Сформировать документ
                        </button>
                    )}

                    {doc.DocumentId && (
                        <div className="col-0">
                            {(doc.OrganizerCanSign || doc.WinnerCanSign) && (
                                <div className="signData">
                                    <input type="hidden" id="hdnSignInfo" value={doc.DataToSign} />
                                    <input type="hidden" id="hdnExistingSignData" value={doc.Signature} />
                                </div>
                            )}

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px"
                                }}
                            >
                                <a
                                    id="btnCreateDocument"
                                    href={"/Document/Details/" + doc.DocumentId}
                                    download
                                    role="button"

                                    style={{
                                        width: "200px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        padding: "0",
                                        display: "inline-block"
                                    }}
                                >
                                    {doc.DocumentName}
                                </a>
                                <img
                                    style={{ width: 20, height: 20 }}
                                    src="../../../Content/MithraThemeV2/img/file_type_pdf_icon_130274.svg"
                                    alt="PDF icon"
                                />
                            </div>

                            {props.LotTradeStatusId === TradeStatus.Traded && (
                                <>
                                    {doc.WinnerSignStatus === SignStatusses.CorrectSign &&
                                        doc.OrganizerSignStatus === SignStatusses.CorrectSign && (
                                            <div>
                                                <a
                                                    href={"/Document/GetSignature/" + doc.DocumentId}
                                                    download
                                                    role="button"
                                                    className="btn btn-primary btn-font-14 btn-block px-10 btn-sm-mobile"
                                                >
                                                    Скачать подпись
                                                </a>
                                            </div>
                                        )}
                                    <div>
                                        {(doc.OrganizerSignStatus === doc.WinnerSignStatus && !props.ArtTheme) &&
                                            (doc.OrganizerSignStatus !== 0) ? (
                                            <span>{doc.SignStatusDescription}</span>
                                        ) : (
                                            <>
                                                <span>
                                                    {doc.OrganizerSignStatus === SignStatusses.SuccessProtocolPartiallySigned
                                                        ? "Подписано организатором"
                                                        : (doc.OrganizerCanSign
                                                            ? <button style={{textDecoration: "underline"}} onClick={handleSignProtocol} title="Подписать">Подписать</button>
                                                        : "Не подписан организатором"
                                                    )
                                                    }
                                                </span>
                                                <span>
                                                    {doc.WinnerSignStatus === SignStatusses.SuccessProtocolPartiallySigned
                                                        ? "Подписано победителем"
                                                        : (doc.WinnerCanSign
                                                            ? <button style={{textDecoration: "underline"}} onClick={handleSignProtocol} title="Подписать">Подписать</button>
                                                            : "Не подписан победителем"
                                                        )
                                                    }
                                                </span>
                                            </>
                                        )}
                                    </div>
                                </>
                            )}

                            {props.LotTradeStatusId === TradeStatus.TradeAbandoned && (
                                <>
                                    {doc.OrganizerSignStatus === SignStatusses.CorrectSign && (
                                        <div>
                                            <a
                                                href={"/Document/GetSignature/" + doc.DocumentId}
                                                download
                                                role="button"
                                                className="btn btn-primary btn-font-14 btn-block px-10 btn-sm-mobile"
                                            >
                                                Скачать подпись
                                            </a>
                                        </div>
                                    )}
                                    <div>
                                        {(doc.OrganizerSignStatus === doc.WinnerSignStatus) &&
                                            (doc.OrganizerSignStatus !== 0) ? (
                                            <span>{doc.SignStatusDescription}</span>
                                        ) : (
                                            <span>
                                                {doc.OrganizerSignStatus === SignStatusses.CorrectSign
                                                    ? "Подписано организатором"
                                                    : (doc.OrganizerCanSign
                                                        ? <button style={{textDecoration: "underline"}} onClick={handleSignProtocol} title="Подписать">Подписать</button>
                                                        : "Не подписан организатором"
                                                    )
                                                }
                                            </span>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </div>
            )}

            {/* Краткая форма - для Моя активность*/}
            {props.IsShortInfo && (
                <div className="col-0">
                    {!doc.DocumentId && doc.IsOrganizer && (
                        <button
                            id="btnCreateDocument"
                            className="btn btn-primary btn-font-14 btn-lg btn-block px-10 btn-sm-mobile defaultPinkButton"
                            onClick={handleCreatePdf}
                        >
                            Сформировать документ
                        </button>
                    )}

                    {doc.DocumentId && (
                        <>
                            {(doc.OrganizerCanSign || doc.WinnerCanSign) && (
                                <div className="signData">
                                    <input type="hidden" id="hdnSignInfo" value={doc.DataToSign} />
                                    <input type="hidden" id="hdnExistingSignData" value={doc.Signature} />
                                </div>
                            )}

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px"
                                }}
                            >
                                <a
                                    id="btnCreateDocument"
                                    href={"/Document/Details/" + doc.DocumentId}
                                    download
                                    role="button"

                                    style={{
                                        width: "200px",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        padding: "0",
                                        display: "inline-block"
                                    }}
                                >
                                    Скачать протокол торгов
                                </a>
                                <img
                                    style={{ width: 20, height: 20 }}
                                    src="../../../Content/MithraThemeV2/img/file_type_pdf_icon_130274.svg"
                                    alt="PDF icon"
                                />
                            </div>

                            {doc.OrganizerCanSign &&
                                (doc.OrganizerSignStatus !== SignStatusses.CorrectSign && doc.OrganizerSignStatus !== SignStatusses.SuccessProtocolPartiallySigned) &&
                                !props.ArtTheme && (
                                <button style={{textDecoration: "underline"}} onClick={(e) => {e.preventDefault();
                                        handleSignProtocolShort();
                                }} title="Подписать">Подписать</button>
                            )}
                        </>
                    )}
                </div>
            )}
        </>
    );
}

export default LotWinnerProtocol;